var _path, _line, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2C22.6797 2 28.5 7.8203 28.5 15C28.5 22.1797 22.6797 28 15.5 28C8.3203 28 2.5 22.1797 2.5 15C2.5 7.8203 8.3203 2 15.5 2Z",
    fill: "white",
    stroke: "#ED1002",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.74976,
    y1: 14.25,
    x2: 25.0831,
    y2: 14.25,
    stroke: "#ED1002",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9167 5.4165V23.7498",
    stroke: "#ED1002",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewRed);
export default __webpack_public_path__ + "static/media/add-new-red.57482f7b29a064d8ba8881f938d87c28.svg";
export { ForwardRef as ReactComponent };